module.exports = __webpack_public_path__ + "static/media/NewContract – Arabic.b0e68a74.jpg";